// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N8Fc","delete":"styles_delete__2II9h","update":"styles_update__3WOmN","add":"styles_add__2vnzu"};